import { InjectionToken } from '@angular/core';

import { KIOSK_PAYMENT_METHOD_PICKER_FALLBACK_I18N_KEYS } from '@front-platform/content-builder';
import { DoodOrderModel } from '@store/order/order.model';
import { IPaymentMethod, PaymentMethodHandles } from '@config/payment-methods.config';

import { KioskPaymentMethodPickerStep } from './kiosk-payment-method-picker-step-enum';

/** Runtime VM emitted by `KioskPaymentMethodPickerBlock` preview data sources. */
export type KioskPaymentMethodPickerBlockViewModel = {
  headingChoosePaymentMethod: string;
  choicePayOnSite: string;
  choicePayOnKiosk: string;
  terminalInstructionMessage: string;
  payOnKioskText: string;
  displayPayOnKioskImage: boolean;
  payOnKioskImage: {
    url: string;
    width?: number;
    height?: number;
  };
  order: Partial<DoodOrderModel> | null;
  availablePaymentMethods: readonly IPaymentMethod[];
  step: KioskPaymentMethodPickerStep;
  selectedPaymentMethodHandle?: PaymentMethodHandles;
};

export const KIOSK_PAYMENT_METHOD_PICKER_BLOCK_LOADING_VM: KioskPaymentMethodPickerBlockViewModel =
  {
    headingChoosePaymentMethod:
      KIOSK_PAYMENT_METHOD_PICKER_FALLBACK_I18N_KEYS.headingChoosePaymentMethod,
    choicePayOnSite: KIOSK_PAYMENT_METHOD_PICKER_FALLBACK_I18N_KEYS.choicePayOnSite,
    choicePayOnKiosk: KIOSK_PAYMENT_METHOD_PICKER_FALLBACK_I18N_KEYS.choicePayOnKiosk,
    terminalInstructionMessage:
      KIOSK_PAYMENT_METHOD_PICKER_FALLBACK_I18N_KEYS.terminalInstructionMessage,
    payOnKioskText: KIOSK_PAYMENT_METHOD_PICKER_FALLBACK_I18N_KEYS.payOnKioskText,
    displayPayOnKioskImage: true,
    payOnKioskImage: {
      url: '/assets/images/kiosk-default-pay-on-kiosk.png',
    },
    order: null,
    availablePaymentMethods: [],
    step: KioskPaymentMethodPickerStep.CHOICE,
  };

export interface KioskPaymentMethodPickerBlockDataSource {
  readonly vm$: import('rxjs').Observable<KioskPaymentMethodPickerBlockViewModel | null>;
}

export const KIOSK_PAYMENT_METHOD_PICKER_BLOCK_DATA_SOURCE =
  new InjectionToken<KioskPaymentMethodPickerBlockDataSource>(
    'KIOSK_PAYMENT_METHOD_PICKER_BLOCK_DATA_SOURCE',
  );
